module.exports = __webpack_public_path__ + "static/media/LR.931285b9.png";